import { Smartphone } from 'lucide-react';

import { useTranslation } from '@splitfiesta/i18n';
import { Card } from '@splitfiesta/ui';

import { StoreButtons } from '@/components/common/StoreButtons';
import { StoreQrCodes } from '@/components/common/StoreQrCodes';

import { getAppStoreConfig } from '@/config/appStore';
import { isMobile } from '@/utils/platform';

/** Settings card: QR codes on desktop, badges on phones. Never dismissed. */
export function GetTheAppSection() {
  const { t } = useTranslation('common');

  if (!getAppStoreConfig().anyAvailable) return null;

  return (
    <Card data-testid="settings-get-app-card">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 flex items-center">
        <Smartphone className="w-5 h-5 mr-2" />
        {t('nativeApp.settings.title')}
      </h3>
      {isMobile() ? (
        <StoreButtons />
      ) : (
        <>
          <div className="md:hidden" data-testid="settings-get-app-badges">
            <StoreButtons />
          </div>
          <StoreQrCodes />
        </>
      )}
    </Card>
  );
}
